<template>
  <el-dialog :visible.sync="addclassVisible" :before-close="handlerClose" :show-close="false"
    :custom-class="radio === '2' ? 'dialogclass' : ''" @open="open">
    <!-- :custom-class="{'dialogclass':radio==='2'}" -->
    <div slot="title" class="el-dialog__title">
      <div class="title-left"></div>
      <slot name="title">{{ $t("managementV2.addStudents") }}</slot>
      <div class="title-right"></div>
    </div>
    <div class="header">
      <div class="addpattern">
        <el-radio-group v-model="radio" @change="changeRadio">
          <el-radio label="1">{{
            $t("managementV2.AddfromOrganizationalStructure")
          }}</el-radio>
          <el-radio label="2">{{ $t("managementV2.qrcodeadding") }}</el-radio>
        </el-radio-group>
      </div>
    </div>
    <div class="tree-table" v-show="radio === '1'">
      <div class="tree" ref="tree">
        <div class="fileter">
          <el-input v-model.trim="searchVal" :placeholder="$t('projectDetailsV2.search')" size="small" clearable
            @clear="changeClear" @focus="handleFocus">
          </el-input>
          <i class="search_i" @click="handelerSeachClick"></i>
        </div>
        <div class="list-box" v-if="!isShowSearchBox" v-show="isShowListBox">
          <!-- 面包屑 -->
          <div class="title">
            <!-- 全选 -->
            <el-checkbox v-model="checkedAll" @change="changeCheckedAll"></el-checkbox>
            <div class="breadcrumb" ref="breadcrumb">
              <span v-for="(item, index) in breadcrumbList" :key="item.id"
                :class="{ active: index == breadcrumbList.length - 1 }" @click="handelerClickBread(item, index)">
                {{ item.name }}
              </span>
            </div>
          </div>
          <div class="depart-box" ref="scrollBox">
            <!-- 部门列表 -->
            <div class="depart-list">
              <div class="depart-list-item" v-for="item in curDepartList" :key="item.id">
                <el-checkbox v-model="item.checked" @change="(val) => changeCheckBox(val, item)"></el-checkbox>
                <div class="depart-info">
                  <el-tooltip class="item" effect="dark" :content="`${item.name}`" placement="top-start"
                    :disabled="isShowTooltip">
                    <div class="depart-name" @mouseover="onMouseOver(item.id)">
                      <span :ref="`str${item.id}`">{{ item.name }}</span>
                    </div>
                  </el-tooltip>
                  <span class="depart-num">（{{ item.departCount }}）</span>
                </div>
                <div class="depart-children">
                  <span v-if="!item.checked" @click="toChildrenDepart(item)">{{
                    $t("managementV2.subordinate")
                  }}</span>
                  <el-link type="primary" disabled v-else>{{
                    $t("managementV2.subordinate")
                  }}</el-link>
                </div>
              </div>
            </div>
            <!-- 人员列表 -->
            <div class="person-list">
              <div class="person-list-item" v-for="i in curStudentList" :key="i.id">
                <el-checkbox v-model="i.checked" @change="(val) => changeCheckBox(val, i)"
                  :disabled="i.classStatus == 1"></el-checkbox>
                <div class="person-info">
                  <span>{{ i.nickName.charAt(0) }}</span>
                  <div class="person-name">{{ i.nickName }}</div>
                </div>
                <div class="hasjoin" v-if="i.classStatus == 1">
                  <span class="join-ico"></span>
                  <span>{{ $t("managementV2.joined") }}</span>
                </div>
              </div>
            </div>
            <div v-show="hasNotMore" class="hasnotmore">
              <span>{{ $t("managementV2.hasNotMore") }}...</span>
            </div>
          </div>
        </div>
        <div class="search-box" v-else>
          <el-card>
            <span v-if="searchList.length == 0">{{
              $t("managementV2.startSearchByKeyword")
            }}</span>
            <div v-else class="search-list">
              <!-- 人员列表 -->
              <div class="person-list">
                <!-- <div class="person-list" ref="searchScrollBox" @scroll="toLoadMoreSearch"> -->
                <div class="person-list-item" v-for="i in searchList" :key="i.id">
                  <el-checkbox v-model="i.checked" @change="(val) => changeSearchCheckBox(val, i)"
                    :disabled="i.classStatus == 1"></el-checkbox>
                  <div class="person-info">
                    <span class="avtor">{{ i.nickName.charAt(0) }}</span>
                    <div class="person-name">{{ i.nickName }}</div>
                  </div>
                  <div class="hasjoin" v-if="i.classStatus == 1">
                    <span class="join-ico"></span>
                    <span>{{ $t("managementV2.joined") }}</span>
                  </div>
                </div>
                <div v-show="hasNotMoreSearch" class="hasnotmore">
                  <span>{{ $t("managementV2.hasNotMore") }}...</span>
                </div>
              </div>
            </div>
          </el-card>
        </div>
      </div>
      <div class="table">
        <div class="checked-title">
          <div class="checked-title-icon"></div>
          <div class="checked-title-text">
            {{ $t("managementV2.selected") }}
          </div>
        </div>
        <div class="checked-list">
          <el-tag v-for="tag in checkedList" :key="tag.id" :closable="handleClosable(tag)" type=""
            @close="handleClose(tag)">
            {{ tag.name || tag.nickName }}
          </el-tag>
        </div>
      </div>
    </div>
    <div class="code" v-show="radio != '1'">
      <img :src="urlBase64" alt="" />
      <div class="tips">
        <span @click="handleCopy">{{ $t("managementV2.copyLink") }}</span>{{ $t("managementV2.toWechatOrQQ") }}
      </div>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button @click="handlerClose" size="small">{{
        $t("managementV2.cancel")
      }}</el-button>
      <el-button type="primary" @click="determine" size="small" v-if="radio === '1'">
        {{ $t("managementV2.add") }}
      </el-button>
    </div>
  </el-dialog>
</template>
<script>
import {
  queryPageTeam,
  queryUserDepartTree,
  getTeamUserPage,
} from "@/services/teamManagement";
import { onCopy } from "@/utils/index";
import {
  saveClass,
  createClassQrCode,
  getUserTotalNum,
} from "@/services/managements";
export default {
  name: "addClassDialog",
  data() {
    return {
      radio: "1",
      qrCodeUrl: "",
      roleArr: [
        {
          value: 3,
          label: this.$t("managementV2.leader"),
        },
        {
          value: 1,
          label: this.$t("managementV2.teacher"),
        },
        {
          value: 2,
          label: this.$t("managementV2.student"),
        },
        {
          value: 0,
          label: this.$t("managementV2.ordinary"),
        },
      ],
      noGroupId: null,
      urlBase64: "",
      Debounce: false,
      companyCode: JSON.parse(localStorage.getItem("userInfo")).selfCompany.code,
      treeData: [], //原始部门列表
      departList: [], //部门列表
      curDepartList: [], //当前部门列表
      curStudentList: [], //当前学生成员列表
      isDefaultGroup: {}, //未分组的信息
      curGroup: {}, //当前分组
      checkedAll: false, //全选
      checkedList: [], //被选中的部门和人员
      searchVal: "", //搜索关键字
      searchList: [], //搜索结果
      isShowSearchBox: false, //是否展示搜索列表
      breadcrumbList: [], //面包屑列表
      isShowListBox: false, //是否展示列表
      stuPage: 1, //学生分页
      stuRows: 20, //学生条数
      searchPage: 1, //搜索分页
      searchRows: 30, //搜索条数
      hasNotMore: false, //没有更多了
      hasNotMoreSearch: false, //没有更多了结果了
      isShowTooltip: false, //展示气泡
    };
  },
  props: {
    addclassVisible: {
      type: Boolean,
      default: () => false,
    },
    addstudentId: {
      type: Number,
    },
  },
  watch: {
    curDepartList: {
      handler(val) {
        if (val.length > 0) {
          this.checkedAll =
            val.every((item) => item.checked == true) &&
            this.curStudentList.every((item) => item.checked == true);
        } else {
          this.checkedAll = this.curStudentList.every(
            (item) => item.checked == true
          );
        }
      },
      deep: true,
    },
    curStudentList: {
      handler(val) {
        if (val.length > 0) {
          this.checkedAll =
            val.every((item) => item.checked == true) &&
            this.curDepartList.every((item) => item.checked == true);
        } else {
          this.checkedAll = this.curDepartList.every(
            (item) => item.checked == true
          );
        }
        // this.getCheckedList()
      },
      deep: true,
    },
    isShowSearchBox: {
      handler(val) {
        if (!val) {
          this.searchList = [];
        }
      },
      deep: true,
    },
    breadcrumbList: {
      handler() {
        let ele = this.$refs.breadcrumb;
        this.$nextTick(() => {
          ele.scrollLeft = ele?.scrollWidth - ele.clientWidth;
        });
      },
    },
    checkedList: {
      handler(val) {
        // this.curDepartList.forEach(i=>{
        //   val.forEach(j=>{
        //     if()
        //   })
        // })
      },
    },
  },
  methods: {
    onMouseOver(str) {
      // 内容超出，显示文字提示内容
      const tag = this.$refs[`str${str}`];
      const parentWidth = tag[0].parentNode.offsetWidth; // 获取元素父级可视宽度
      const contentWidth = tag[0].offsetWidth; // 获取元素可视宽度
      this.isShowTooltip = contentWidth <= parentWidth;
    },
    //全选/全不选
    changeCheckedAll(val) {
      this.curDepartList.forEach((item) => (item.checked = val));
      this.curStudentList.forEach((item) => {
        //如果已加入不改
        if (item.classStatus != 1) {
          item.checked = val;
        }
      });
      if (val) {
        this.checkedList = this.checkedList.filter(
          (x) => !this.curDepartList.some((y) => y.id === x.id)
        );
        this.checkedList = this.checkedList.filter(
          (x) => !this.curStudentList.some((y) => y.id === x.id)
        );
        this.checkedList.push(
          this.breadcrumbList[this.breadcrumbList.length - 1]
        );
      } else {
        this.checkedList = this.checkedList.filter(
          (item) =>
            item.id != this.breadcrumbList[this.breadcrumbList.length - 1].id
        );
      }
      // let arr = JSON.parse(JSON.stringify(this.checkedList))
      // let arr2 = []
      // let departArr = JSON.parse(JSON.stringify(this.curDepartList))
      // let studentArr = this.curStudentList.filter(item => item.classStatus != 1)
      // console.log(studentArr);
      // arr2.push(...departArr)
      // arr2.push(...studentArr)
      // if (val) {
      //   console.log(arr2);
      //   arr.push(...arr2)
      //   this.checkedList = arr
      // } else {
      //   this.checkedList = arr.filter(item => !arr2.some(ele => ele.id === item.id));
      // }
    },
    //选框改变时
    changeCheckBox(val, i) {
      if (val) {
        this.curStudentList = this.curStudentList.map((item) => {
          if (item.id == i.id) {
            item = i;
          }
          return item;
        });
        this.checkedList.push(i);
        this.$nextTick(() => {
          //如果全选中了
          let flag =
            this.curDepartList.every((item) => item.checked == true) &&
            this.curStudentList.every((item) => item.checked == true);
          if (flag) {
            this.checkedList = this.checkedList.filter(
              (x) => !this.curDepartList.some((y) => y.id === x.id)
            );
            this.checkedList = this.checkedList.filter(
              (x) => !this.curStudentList.some((y) => y.id === x.id)
            );
            this.checkedList.push(
              this.breadcrumbList[this.breadcrumbList.length - 1]
            );
          }
        });
      } else {
        this.curStudentList = this.curStudentList.map((item) => {
          if (item.id == i.id) {
            item = i;
          }
          return item;
        });
        this.checkedList.forEach((item, index) => {
          if (item.id == i.id) {
            this.checkedList.splice(index, 1);
          }
          if (
            item.id == this.breadcrumbList[this.breadcrumbList.length - 1].id
          ) {
            this.checkedList.splice(index, 1);
            let arr = this.curDepartList.filter((item) => item.checked == true);
            let arr1 = this.curStudentList.filter(
              (item) => item.checked == true && item.classStatus != 1
            );
            this.checkedList.push(...arr);
            this.checkedList.push(...arr1);
          }
        });
      }
    },
    //搜索选框改变时
    changeSearchCheckBox(val, i) {
      if (val) {
        //判断有欸有
        let flag = this.checkedList.findIndex((item) => item.id == val.id);
        if (flag == "-1") {
          this.checkedList.push(i);
          this.curStudentList.forEach((item) => {
            if (item.id == i.id) {
              item.checked = true;
            }
          });
        }
      } else {
        this.checkedList.forEach((item, index) => {
          if (item.id == i.id) {
            this.checkedList.splice(index, 1);
          }
        });
        this.curStudentList.forEach((item) => {
          if (item.id == i.id) {
            item.checked = false;
          }
        });
      }
    },
    //获取当前学生成员列表
    async getCurStudentList(params) {
      params = params || {
        filter: {
          classId: this.addstudentId,
          departId: this.curGroup.id,
          companyCode: JSON.parse(localStorage.getItem("userInfo")).selfCompany
            .code,
        },
        // page: this.stuPage,
        // rows: this.stuRows,
        // sort: {},
      };
      let res = await getTeamUserPage(params);
      if (res.success) {
        // this.stuPage = this.stuPage + 1
        let arr = res.result;
        // let arr2 = []
        // let arr3 = JSON.parse(JSON.stringify(this.checkedList))
        //如果是已加入，默认选中
        arr.forEach((i) => {
          if (i.classStatus == 1) {
            i["checked"] = true;
            i["disabled"] = true;
            // arr2.push(i)
          }
        });

        // this.checkedList = arr2.reduce((a, b) => {
        //   let isFlag = false
        //   a.forEach(item => {
        //     if (item.id === b.id) {
        //       isFlag = true
        //       item = Object.assign(item, b)
        //     }
        //   })
        //   if (!isFlag) {
        //     a.push(b)
        //   }
        //   return a
        // }, arr3)
        //已选中，再次获取继续选中
        arr.forEach((i) => {
          this.checkedList.forEach((j) => {
            if (i.id == j.id) {
              i.checked = true;
            }
            if (j.id == this.curGroup.id || j.id == 1) {
              i.checked = true;
            }
          });
        });
        this.curStudentList.push(...arr);
        // if (this.curStudentList.length == res.totalRows) {
        this.hasNotMore = true;
        // }
        this.isShowListBox = true;
      }
    },
    //获取被选中的部门和人员
    getCheckedList() { },
    //是否可以删除
    handleClosable(tag) {
      if (tag.hasOwnProperty("classStatus")) {
        return tag.classStatus != 1;
      } else {
        return true;
      }
    },
    //删除tag
    handleClose(tag) {
      this.checkedList.splice(this.checkedList.indexOf(tag), 1);
      if (this.breadcrumbList[this.breadcrumbList.length - 1].id == tag.id) {
        this.curDepartList.forEach((item) => {
          item.checked = false;
        });
        this.curStudentList.forEach((item) => {
          if (item.companyStatus != 1) {
            item.checked = false;
          }
        });
      }
      this.curDepartList.forEach((item) => {
        if (item.id == tag.id) {
          item.checked = false;
        }
      });
      this.curStudentList.forEach((item) => {
        if (item.id == tag.id) {
          item.checked = false;
        }
      });
    },
    //点击搜索
    handelerSeachClick() {
      this.searchList = [];
      this.isShowSearchBox = true;
      if (this.searchVal == "") {
        this.isShowSearchBox = false;
        return;
      }
      this.search();
    },
    //搜索
    async search() {
      this.isShowSearchBox = true;
      let params = {
        filter: {
          classId: this.addstudentId,
          keyword: this.searchVal,
          companyCode: JSON.parse(localStorage.getItem("userInfo")).selfCompany
            .code,
        },
        // page: this.searchPage,
        // rows: this.searchRows,
        // sort: {},
      };
      let res = await getTeamUserPage(params);
      if (res.success) {
        // this.searchPage = this.searchPage + 1
        let arr = res.result;
        if (arr.length == 0) {
          this.$message.warning(this.$t("managementV2.notFindResult"));
        }
        arr.forEach((i) => {
          this.checkedList.forEach((j) => {
            if (i.id == j.id) {
              i["checked"] = true;
              i["disabled"] = true;
            }
          });
        });
        this.searchList.push(...arr);
        // if (this.searchList.length == res.totalRows) {
        this.hasNotMoreSearch = true;
        // }
        this.isShowListBox = true;
      }
    },
    //获取所有的学生
    async queryAllStudentList() {
      let params = {
        filter: {
          classId: this.addstudentId,
          keyword: "",
          companyCode: JSON.parse(localStorage.getItem("userInfo")).selfCompany
            .code,
        },
      };
      let res = await getTeamUserPage(params);
      if (res.success) {
        let arr = res.list;
        arr.forEach((item) => {
          if (item.classStatus == 1) {
            this.checkedList.push(item);
          }
        });
      }
    },
    //清空
    changeClear() {
      // this.stuPage = 1
      this.isShowListBox = true;
      this.hasNotMore = false;
      this.isShowSearchBox = true;
      this.searchVal = "";
      this.searchList = [];
      console.log(this.searchList);
    },
    //获取焦点
    handleFocus() {
      this.isShowSearchBox = true;
    },
    //去下级部门
    toChildrenDepart(item) {
      this.stuPage = 1;
      this.isShowListBox = false;
      this.hasNotMore = false;
      this.hasNotMoreSearch = false;
      this.isShowListBox = false;
      this.getBrnList(item);
      this.curStudentList = [];
      this.curDepartList = [...item.children];
      let params = {
        filter: {
          classId: this.addstudentId,
          departId: item.id,
          companyCode: JSON.parse(localStorage.getItem("userInfo")).selfCompany
            .code,
        },
        page: this.searchPage,
        rows: this.searchRows,
        sort: {},
      };
      const { success } = this.getCurStudentList(params);
      if (success) {
        this.isShowListBox = true;
      }
    },
    //点击面包屑
    handelerClickBread(item, index) {
      if (index == this.breadcrumbList.length - 1) {
        return;
      } else {
        this.curGroup = item;
        this.curStudentList = [];
        this.stuPage = 1;
        this.isShowListBox = false;
        this.hasNotMore = false;
        this.hasNotMoreSearch = false;
        this.isShowListBox = false;
        this.getBrnList(item);
        let arr = [...item.children];
        arr.forEach((i) => {
          i.checked = false;
          this.checkedList.forEach((j) => {
            if (i.id == j.id) {
              i.checked = true;
            }
            if (j.id == i.parentId) {
              i.checked = true;
            }
          });
        });
        this.curDepartList = arr;
        // let params = {
        //   filter: {
        //     classId: this.addstudentId,
        //     departId: item.id,
        //     companyCode: JSON.parse(localStorage.getItem("userInfo")).selfCompany.code
        //   },
        // page: this.searchPage,
        // rows: this.searchRows,
        // sort: {},
        // }
        if (item.id == 1) {
          this.curGroup = this.isDefaultGroup;
        }
        this.getCurStudentList();
      }
    },
    //获取面包屑列表
    getBrnList(data) {
      let arr = [...this.treeData];
      let newArr = [];
      function getAllParentNodeIds(tree, childId, parentIds) {
        for (let i in tree) {
          let item = tree[i];
          if (item.id === childId.id) {
            //将查找到的目标数据加入结果数组中
            //可根据需求unshift(item.id)或unshift(item)
            parentIds.unshift(item);
            return true;
          }
          if (item.children && item.children.length > 0) {
            let ok = getAllParentNodeIds(item.children, childId, parentIds);
            if (ok) {
              parentIds.unshift(item);
              return true;
            }
          }
        }
        //走到这说明没找到目标
        return false;
      }
      getAllParentNodeIds(arr, data, newArr);
      //存到vuex
      this.breadcrumbList = newArr;
    },
    //滚动请求
    toLoadMore() {
      let scrollDom = this.$refs.scrollBox;
      if (
        scrollDom.clientHeight + scrollDom.scrollTop + 1 >=
        scrollDom.scrollHeight
      ) {
        this.getCurStudentList(); //发送请求获取数据
      }
    },
    toLoadMoreSearch() {
      let scrollDom = this.$refs.searchScrollBox;
      if (
        scrollDom.clientHeight + scrollDom.scrollTop + 1 >=
        scrollDom.scrollHeight
      ) {
        this.search(); //发送请求获取数据
      }
    },
    //初始化
    open() {
      this.$nextTick(() => {
        document.addEventListener("click", (e) => {
          if (!this.$refs.tree?.contains(e.target)) this.isShowSearchBox = false;
        });
      });
      this.searchVal = "";
      this.breadcrumbList = [];
      this.departList = [];
      this.curDepartList = [];
      this.curStudentList = [];
      this.checkedList = [];
      this.checkedAll = false;
      this.isShowSearchBox = false;
      this.isShowListBox = false;
      this.hasNotMore = false;
      this.hasNotMoreSearch = false;
      this.searchList = [];
      this.getTerrClass();
    },
    isdisabled(row) {
      if (parseInt(row.classStatus) === 1) {
        return false;
      } else {
        return true;
      }
    },
    //格式化角色
    roleFormate(row) {
      let item = this.roleArr.find((item) => item.value === row.identityType);
      return item.label;
    },
    //格式化状态
    statusFormate(status) {
      switch (status) {
        case 1:
          return this.$t("managementV2.joined");
        default:
          return this.$t("managementV2.notToJoin");
      }
    },
    //获取树形结构数据
    async getTerrClass() {
      let params = {
        companyCode: this.companyCode,
        identityType: 2,
      };
      let { success, result } = await queryUserDepartTree(params);
      if (success) {
        //初始面包屑列表
        this.breadcrumbList.push(result);
        this.treeData = [result];
        let arr = result.children.filter((item) => item.isDefaultGroup !== 1);
        this.isDefaultGroup = result.children.find(
          (item) => item.isDefaultGroup === 1
        );
        this.departList = arr;
        //去掉未分组
        this.breadcrumbList[0].children = arr;
        this.departList.forEach((item) => {
          this.$set(item, "checked", false);
        });

        this.curDepartList = this.departList;
        // // 拿到未分组id
        this.noGroupId = this.isDefaultGroup.id;
        this.curGroup = Object.assign(this.isDefaultGroup);
        this.getCurStudentList();
      }
    },
    fromateIndex(index) {
      if (index < 9) {
        return "0" + (index + 1);
      } else {
        return index + 1;
      }
    },
    //创建验证码
    async createClassQrCode() {
      let params = {
        classId: this.addstudentId,
        companyCode: JSON.parse(localStorage.getItem("userInfo")).selfCompany
          .code,
      };
      const { result, success } = await createClassQrCode(params);
      if (success) {
        // console.log("333")
        this.urlBase64 = "data:image/png;base64," + result.urlBase64;
        // console.log(this.urlBase64)
        this.qrCodeUrl = result.qrCodeUrl;
      }
    },
    changeRadio(val) {
      this.radio = val;
      if (this.radio === "2") {
        this.createClassQrCode();
      }
    },
    handleCopy() {
      onCopy(this.qrCodeUrl);
      this.$message.closeAll();
      this.$message.success(this.$t("common.copySuccess"));
    },
    //关闭
    handlerClose() {
      this.searchVal = "";
      this.breadcrumbList = [];
      this.departList = [];
      this.curDepartList = [];
      this.curStudentList = [];
      this.checkedList = [];
      this.checkedAll = false;
      this.hasNotMore = false;
      this.hasNotMoreSearch = false;
      this.isShowSearchBox = false;
      this.isShowListBox = false;
      this.searchList = [];
      if (this.radio === "2") {
        this.$emit("handlerclassClose", true);
      } else {
        this.$emit("handlerclassClose", false);
      }
      this.radio = "1";
    },
    //添加
    async determine() {
      if (this.Debounce) {
        return false;
      }
      this.Debounce = true;
      let timer = window.setTimeout(() => {
        clearTimeout(timer);
        this.Debounce = false;
      }, 1000);
      let arr = [...this.checkedList];
      let departIdList = [];
      let userIdList = [];
      arr.forEach((item) => {
        if (item.hasOwnProperty("classStatus")) {
          userIdList.push(item.userId);
        } else {
          departIdList.push(item.id);
        }
      });
      let params = {
        classId: this.addstudentId,
        departIdList: departIdList,
        userIdList: userIdList,
        companyCode: JSON.parse(localStorage.getItem("userInfo")).selfCompany
          .code,
      };
      const { success } = await saveClass(params);
      if (success) {
        this.$message.success(this.$t("managementV2.Studentaddedsuccessfully"));
        this.$emit("handlerStudentSuccess");
      }
    },
  },
};
</script>
<style lang="less" scoped>
@import url(./assets/addClassDialog.less);
</style>
